var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.788,
    height: 47.771,
    viewBox: "0 0 48.788 47.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Balance",
    transform: "translate(-931.212 -207.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(-3.788 37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(935 170.819)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 24.394,
    cy: 23.886,
    rx: 24.394,
    ry: 23.886,
    fill: "#edfff5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Suitcase_Financial_Portfolio",
    "data-name": "Suitcase, Financial, Portfolio",
    transform: "translate(943 217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M0,0H26.666V26.666H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M20.777,21.944H5.222A2.222,2.222,0,0,1,3,19.722v-10A2.222,2.222,0,0,1,5.222,7.5H20.777A2.222,2.222,0,0,1,23,9.722v10A2.222,2.222,0,0,1,20.777,21.944Z",
    transform: "translate(0.333 0.833)",
    fill: "none",
    stroke: "#3ecc97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M20.777,21.944H5.222A2.222,2.222,0,0,1,3,19.722v-10A2.222,2.222,0,0,1,5.222,7.5H20.777A2.222,2.222,0,0,1,23,9.722v10A2.222,2.222,0,0,1,20.777,21.944Z",
    transform: "translate(0.333 0.833)",
    fill: "#3ecc97",
    stroke: "#3ecc97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M17.1,7.944V5.722A2.222,2.222,0,0,0,14.879,3.5H10.048A2.222,2.222,0,0,0,7.826,5.722V7.944",
    transform: "translate(0.869 0.389)",
    fill: "none",
    stroke: "#3ecc97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M12,11.111V10",
    transform: "translate(1.333 1.111)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M12,17v1.111",
    transform: "translate(1.333 1.888)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M10.293,16.872a1.6,1.6,0,0,0,1.373.8h1.218a1.561,1.561,0,0,0,.379-3.074l-2.083-.523A1.56,1.56,0,0,1,11.56,11h1.218a1.6,1.6,0,0,1,1.37.794",
    transform: "translate(1.111 1.222)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIcon);
export default __webpack_public_path__ + "static/media/balance-icon.116e350cdb14cdae36bf18cdb981d163.svg";
export { ForwardRef as ReactComponent };